import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { HomeHero } from '../components/home/HomeHero';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { ComplaintExplorer } from '../components/ComplaintExplorer';
import { CtaBand } from '../components/CtaBand';
import { TrainingClinic } from '../components/TrainingClinic';
import { TeamMemberCard } from '../components/TeamMemberCard';
import { careSteps, images } from '../data/clinic';
import { team } from '../data/team';
export function Home() {
  const specialists = team[0];
  return <>
      <HomeHero data-id="element-592" data-mp="29fc1ke9hphs7" />

      <section id="waar-pijn" className="scroll-mt-28" data-id="element-593" data-mp="29etwcs4unt85">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24" data-id="element-594" data-mp="2dhyvqltmvesk">
          <div className="mb-10 max-w-2xl" data-id="element-595" data-mp="3kvae4s3vmly6">
            <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-[44px] sm:leading-tight" data-id="element-596" data-mp="3kuihddyjmi6b">
              Waar heeft u pijn?
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-597" data-mp="30xb7fy9sinu3">
              Kies uw pijnklacht. U ziet direct welke behandelingen wij bieden.
            </p>
          </div>
          <ComplaintExplorer data-id="element-598" data-mp="2qylnlzyc2tb7" />
        </div>
      </section>

      <section className="border-t border-line bg-surface" data-id="element-599" data-mp="2qx0vegzhrmgi">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-20 lg:grid-cols-2 lg:gap-20 lg:px-8 lg:py-24" data-id="element-600" data-mp="2mxjork8bwj9r">
          <div data-id="element-601" data-mp="2hy7518cr7sbe">
            <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-602" data-mp="2hyp6cje9wwq6">Tijd voor echte aandacht</h2>
            <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-603" data-mp="2d546elt4dsoc">
              Onze kliniek biedt medisch specialistische behandelingen op het gebied van pijnklachten, overgangsklachten en
              carpaal tunnel syndroom.
            </p>
            <img src={images.consult} alt="Lichte, rustige behandelkamer" className="mt-10 aspect-[16/10] w-full rounded-3xl object-cover" data-id="element-604" data-mp="1z7pdh73nr2rm" />
          </div>
          <div className="lg:pt-2" data-id="element-605" data-mp="1kjnvx6fay9y1">
            <h3 className="font-display text-xl font-semibold text-ink" data-id="element-606" data-mp="1kmtmkq3kxjvv">Zo werkt het</h3>
            <ol className="mt-8" data-id="element-607" data-mp="1onnahjh0uyor">
              {careSteps.map((step, index) => <li key={step.title} className="relative flex gap-6 pb-10 last:pb-0" data-id="element-608" data-mp="1anukjqdbkmhu" data-mpi={index}>
                  {index < careSteps.length - 1 && <span className="absolute left-5 top-11 h-[calc(100%-2.75rem)] w-px bg-line" aria-hidden="true" data-id="element-609" data-mp="23b8c18y90puk" />}
                  <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white font-display text-sm font-semibold text-primary ring-1 ring-line" data-id="element-610" data-mp="2899v3tvocp61">
                    {index + 1}
                  </span>
                  <div className="pt-1.5" data-id="element-611" data-mp="1yif8goeinnk2">
                    <p className="font-display text-lg font-semibold text-ink" data-id="element-612" data-mp="2m9kq9940opx0">{step.title}</p>
                    <p className="mt-1.5 text-[15px] leading-relaxed text-muted" data-id="element-613" data-mp="2r1b3pny93tsn">{step.text}</p>
                  </div>
                </li>)}
            </ol>
          </div>
        </div>
      </section>

      <ReviewsSection data-id="element-614" data-mp="alo6bbvd7xug" />

      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24" data-id="element-615" data-mp="am7n2p9a4g6w">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end" data-id="element-616" data-mp="od2oxhld1x0z">
          <div className="max-w-xl" data-id="element-617" data-mp="kcafan8ktq46">
            <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-618" data-mp="kdc3zuiimb4d">Onze pijnspecialisten</h2>
            <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-619" data-mp="3su6usbm1g523">
              Samen met pijnconsulenten, verpleegkundigen en het secretariaat staan zij voor u klaar.
            </p>
          </div>
          <Link to="/team" className="inline-flex items-center gap-2 whitespace-nowrap text-[15px] font-semibold text-primary hover:text-primary-dark" data-id="element-620" data-mp="5l9zty9ewvyj">
            Bekijk het hele team
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-621" data-mp="1c4855xv7qrbt" />
          </Link>
        </div>
        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-622" data-mp="27eepm9kemzhe">
          {specialists.members.slice(0, 4).map(m => <li key={m.name} data-id="element-623" data-mp="2cdraiorptwhc">
              <TeamMemberCard member={m} data-id="element-624" data-mp="2cf2g8u4q1eb3" />
            </li>)}
        </ul>
      </section>

      <TrainingClinic data-id="element-625" data-mp="2he5muj0cnsl6" />
      <CtaBand data-id="element-626" data-mp="2mb5o8gm9875y" />
    </>;
}